import {useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IAmplitudeOfferPromotionTrackingParams} from "../tracking/get_amplitude_offer_promotion_event_properties";
import {trackAmplitudeOfferViewPromotion} from "../tracking/track_amplitude_offer_promotion_events";

interface IUseAmplitudePromotionViewportTrackingParams {
    trackingContext: IAmplitudeOfferPromotionTrackingParams | null;
    elementId: string;
    disabled?: boolean;
}

export const useAmplitudePromotionViewportTracking = (params: IUseAmplitudePromotionViewportTrackingParams) => {
    const hasTrackedRef = useRef(false);
    const {trackingContext, elementId, disabled} = params;

    useElementWasVisible({
        ids: disabled || !trackingContext ? [] : [elementId],
        onElementVisible: () => {
            if (!trackingContext || hasTrackedRef.current) {
                return;
            }

            hasTrackedRef.current = true;
            trackAmplitudeOfferViewPromotion(trackingContext);
        },
        once: true,
        threshold: 0.05,
        disabled: disabled || !trackingContext
    });

    return {elementId};
};
import {useRef} from "react";

import {useElementWasVisible} from "@pg-mono/hooks";

import {IAmplitudeOfferPromotionTrackingParams} from "../tracking/get_amplitude_offer_promotion_event_properties";
import {trackAmplitudeOfferViewPromotion} from "../tracking/track_amplitude_offer_promotion_events";

interface IUseAmplitudePromotionViewportTrackingParams {
    trackingContext: IAmplitudeOfferPromotionTrackingParams | null;
    elementId: string;
    disabled?: boolean;
}

export const useAmplitudePromotionViewportTracking = (params: IUseAmplitudePromotionViewportTrackingParams) => {
    const hasTrackedRef = useRef(false);
    const {trackingContext, elementId, disabled} = params;

    useElementWasVisible({
        ids: disabled || !trackingContext ? [] : [elementId],
        onElementVisible: () => {
            if (!trackingContext || hasTrackedRef.current) {
                return;
            }

            hasTrackedRef.current = true;
            trackAmplitudeOfferViewPromotion(trackingContext);
        },
        once: true,
        threshold: 0.05,
        disabled: disabled || !trackingContext
    });

    return {elementId};
};
